export const USER_INFO = 'USER_INFO'
export const PLATFORM_INFO = 'PLATFORM_INFO'
export const DIGISIN_INFO = 'DIGISIGN_INFO'
